/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { FunctionComponent, JSX } from "react";

import type { LoadingIndicatorProps } from "./LoadingIndicatorProps";
import loadingIndicator from "../../../model/assets/images/loading-indicator.gif";

import "./LoadingIndicator.scss";

const LoadingIndicator: FunctionComponent<LoadingIndicatorProps> = (
  props: LoadingIndicatorProps
): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-unused-vars, sonarjs/no-dead-store -- Required by CodingGuidelines §7 (D-09) for logging context
  const TAG: string = "LoadingIndicator";
  const { alt = "Loading", className } = props;

  const classNames: string =
    "loading-indicator" + (className !== undefined ? " " + className : "");

  return (
    <div className={classNames}>
      <img
        className="loading-indicator__image"
        src={loadingIndicator}
        alt={alt}
      />
    </div>
  );
};

export default LoadingIndicator;
